<template>
  <div class="race-question">
    <sweet-modal ref="luckyRunner" v-on:close="onClose" class="luckyRunner">
      <p class="title">Today's Lucky LiveRunner is...</p>
      <div class="runnerName">{{details.runner.firstName}}&nbsp;{{details.runner.lastName}}</div>

      <div class="gift">
        <select v-model="gift" label="Gift" name="Gift"  @change="changeHandle">
          <option value disabled selected>{{defaultOption}}</option>
          <option v-for="(gift, index) in lang=='Km'?giftOption:giftOptionEng" v-bind:value="gift" :key="index">{{gift}}</option>
        </select>
      </div>
      <div class="errorMsg" v-if="noGiftSelected">No Gift Selected !!</div>
      <div class="saveBtn">
        <button class="btn btn--primary" v-on:click="Save()" style="float:none">Send</button>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
import Vue from "vue"
import { SweetModal } from "sweet-modal-vue"
import LuckyLiveRunnerService from "../../../services/luckyLiveRunner"
import { db } from "../../../firebase"
import moment from 'moment'

export default {
  name: "lucky-live-runner",
  data: () => ({
    gift: "",
    giftOption: [
      "スターバックスチケット",
      "ハーゲンダッツアイスクリーム",
      "サーティーワンアイスクリーム",
      "スペシャルギフト"
    ],
    defaultOption:'ギフトの内容は？',
    giftOptionEng: ["Jamba Juice", "Starbucks", "3", "Special Gift"],
    lang: "Km",
    noGiftSelected: false
  }),
  props: {
    details: {},
    show: false
  },
  // firebase: {
  //   ${this.$fbDbEntry}: db.ref('${this.$fbDbEntry}')
  // },
  methods: {
    onClose() {
      this.gift = ""
      this.$emit("closed", true)
    },
    openEditModal() {
      this.noGiftSelected = false
      this.lang = Vue.prototype.$envdistanceIn
      if(this.lang=='Miles'){
        this.defaultOption='Select gift'
      }else{
        this.defaultOption='ギフトの内容は？'
      }
      console.log("runner",this.details.runner.LuckyLiveRunnerInfo)
      //console.log("runner",this.details.runner.LuckyLiveRunnerInfo)
      if(this.details.runner.isLuckyLiveRunner && this.details.runner.LuckyLiveRunnerInfo!=undefined){
        this.gift = this.details.runner.LuckyLiveRunnerInfo.presentContent
      }
      this.$refs.luckyRunner.open()
    },
    changeHandle(){
      this.noGiftSelected = false
    },
    Save() {
      this.noGiftSelected = false
      if (this.gift == "") {
        this.noGiftSelected = true
        return
      }
      var data = {
            runDate: this.details.race.date.split("T")[0],
            //runDate:  moment(this.details.race.date).format('YYYY-MM-DD') ,
            //runDateTime:this.details.race.date,
            raceDateTime:this.details.race.date,
            raceId:this.details.race.id,
            runName: this.details.race.name,
            trainerName: this.details.race.trainer.firstName,
            runStartTime: this.details.race.date.split("T")[1].split(":")[0] +":"+ this.details.race.date.split("T")[1].split(":")[1],
            //runStartTime: moment(this.details.race.date).format('hh:mm'),
            runnerId: this.details.runner.id,
            runnerName: this.details.runner.firstName,
            //presentSentDate: new Date().toISOString().replace('T', ' ').substring(0, 10),
            presentSentDate: "",
            presentContent: this.gift,
            note: ""
          }

          //console.log("data---",data)

          LuckyLiveRunnerService.create(data).then(response => {
            //this.$emit('saved', response.data)
            this.$emit('saved', response.data,this.details.index)
            this.gift = ""
            this.$refs.luckyRunner.close()
          }).catch(error => {
            console.log("err---",error)
            this.gift = ""
            this.$refs.luckyRunner.close()
          }) 



      // //if already selected as luckyLiveRunner then update data else add as luckyLiveRunner
      // if(this.details.runner.isLuckyLiveRunner && this.details.runner.LuckyLiveRunnerInfo!=undefined){
      //   //****  Update luckyLiveRunner  **** //
      //   this.details.runner.LuckyLiveRunnerInfo. presentContent=this.gift
      //   LuckyLiveRunnerService.updateLuckyLiveRunnerData(this.details.runner.LuckyLiveRunnerInfo).then(response => {
      //       //this.$emit('saved', response.data)
      //       this.gift = ""
      //       this.$refs.luckyRunner.close()
      //     }).catch(error => {
      //       console.log("update err ---",error) 
      //       this.gift = ""
      //       this.$refs.luckyRunner.close()
      //     })   
      // }else{
      //   //**** Add luckyLiveRunner ****// 
      //     var data = {
      //       runDate: this.details.race.date.split("T")[0],
      //       //runDateTime:this.details.race.date,
      //       raceId:this.details.race.id,
      //       runName: this.details.race.name,
      //       trainerName: this.details.race.trainer.firstName,
      //       runStartTime: this.details.race.date.split("T")[1].split(":")[0] +":"+ this.details.race.date.split("T")[1].split(":")[1],
      //       runnerId: this.details.runner.id,
      //       runnerName: this.details.runner.firstName,
      //       //presentSentDate: new Date().toISOString().replace('T', ' ').substring(0, 10),
      //       presentSentDate: "",
      //       presentContent: this.gift,
      //       note: ""
      //     }

      //     LuckyLiveRunnerService.create(data).then(response => {
      //           //this.$emit('saved', response.data)
      //           this.$emit('saved', response.data,this.details.index)
      //           this.gift = ""
      //           this.$refs.luckyRunner.close()
      //     }).catch(error => {
      //       console.log("err---",error)
      //       this.gift = ""
      //       this.$refs.luckyRunner.close()
      //     })     
      // } 
      
    }
  },
  created() {
    this.$watch("show", function(val) {})
  },

  watch: {
    show(oldVal, newVal) {
      if (this.show) {
        this.openEditModal()
      }
    }
  },
  components: {
    SweetModal
  }
}
</script>
<style>
p.title {
  color: #9c9c9c;
  font-size: 15px;
  padding: 10px;
}
.runnerName {
  padding: 10px;
}
.gift select {
  height: 35px;
  width: 75%;
  background: transparent;
}
.gift {
  padding: 20px 0px;
}
.luckyRunner .sweet-modal {
  border-radius: 30px;
}
.gift select:invalid {
  color: gray;
}
.errorMsg {
  padding: 10px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// LuckyLiveRunner.vue?e4280344